(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aif-purchase-flow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aif-purchase-flow')) {
    class AifPurchaseFlow extends HTMLElement {
      connectedCallback() {
        if (this.setupStarted) return;
        this.setupStarted = true;
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);
        window.requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        window.queueMicrotask(() => {
          if (this.isConnected) return;
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('change', this.handleChange);
          this.form?.removeEventListener('submit', this.handleSubmit, true);
          this.productInfo?.removeEventListener('variant:change', this.handleVariantChange);
          this.observer?.disconnect();
          window.clearTimeout(this.materialAdvanceTimer);
          this.setupStarted = false;
        });
      }

      setup() {
        this.section = this.closest('[data-aif-product-cro]');
        this.form = this.section?.querySelector('form[data-type="add-to-cart-form"]');
        if (!this.section || !this.form) {
          window.setTimeout(() => this.setup(), 120);
          return;
        }

        const buttons = this.form.querySelector('.product-form__buttons');
        if (this.parentElement !== this.form) {
          this.form.insertBefore(this, buttons || null);
        }

        this.form.addEventListener('submit', this.handleSubmit, true);
        this.productInfo = this.closest('product-info');
        this.productInfo?.addEventListener('variant:change', this.handleVariantChange);
        const sizeProductsData = this.querySelector('[data-aif-size-products]');
        this.sizeProducts = JSON.parse(sizeProductsData?.textContent || '{}');
        this.selectedSize = this.dataset.currentSize || 'Medium';
        this.materialConfirmed = false;
        this.shippingThreshold = Number.parseInt(this.dataset.shippingThreshold, 10) || 0;
        const requestedStep = Number.parseInt(new URLSearchParams(window.location.search).get('aif_step'), 10);
        const initialStep = requestedStep === 2 ? 2 : 1;
        this.maxUnlockedStep = initialStep;
        this.observer = new MutationObserver(() => this.moveIntegrations());
        this.observer.observe(this.section, { childList: true, subtree: true });
        this.moveIntegrations();
        this.classList.add('is-enhanced');
        this.syncSizeVariant();
        this.activateStep(initialStep, false);
        this.updateSummaries();
      }

      moveIntegrations() {
        const stepThree = this.querySelector('[data-aif-step-three-controls]');
        const progressTarget = this.querySelector('[data-aif-step-four-progress]');
        const upsellTarget = this.querySelector('[data-aif-step-four-upsell]');
        const quantityTarget = this.querySelector('[data-aif-step-four-quantity]');
        const buttonsTarget = this.querySelector('[data-aif-step-four-buttons]');
        const proofTarget = this.querySelector('[data-aif-step-four-proof]');
        const variantPicker = this.section.querySelector('variant-selects');
        const optionWrapper = this.form.querySelector('.cl-po--wrapper');
        const optionContainer = optionWrapper?.closest('.inject') || optionWrapper;
        const progress = this.form.querySelector('aif-pdp-progress');
        const upsell = this.form.querySelector('[data-essential-upsell-funnel-id]');
        const quantity = this.section.querySelector('.product-form__quantity');
        const buttons = this.form.querySelector('.product-form__buttons');
        const proof = this.section.querySelector('.aif-product-proof');

        if (variantPicker && !stepThree.contains(variantPicker)) stepThree.append(variantPicker);
        if (optionContainer) {
          optionContainer.hidden = true;
          optionContainer.setAttribute('aria-hidden', 'true');
          optionContainer.querySelectorAll('input, select, textarea').forEach((control) => {
            control.required = false;
            control.disabled = true;
          });
        }
        if (progress && !progressTarget.contains(progress)) progressTarget.append(progress);
        if (upsell && !upsellTarget.contains(upsell)) upsellTarget.append(upsell);
        if (quantity && !quantityTarget.contains(quantity)) quantityTarget.append(quantity);
        if (buttons && !buttonsTarget.contains(buttons)) buttonsTarget.append(buttons);
        if (proof && !proofTarget.contains(proof)) proofTarget.append(proof);
        if (this.sizeProducts) this.syncSizeVariant();
        if (Number.isFinite(this.currentVariantPrice)) this.updateShippingMessaging(this.currentVariantPrice);
      }

      handleClick(event) {
        const backButton = event.target.closest('[data-aif-back-step]');
        if (backButton) {
          event.preventDefault();
          window.clearTimeout(this.materialAdvanceTimer);
          this.activateStep(Number.parseInt(backButton.dataset.aifBackStep, 10), true);
          return;
        }

        const sizeChoice = event.target.closest('[data-aif-size-choice]');
        if (sizeChoice) {
          event.preventDefault();
          this.selectSize(sizeChoice.dataset.aifSizeChoice);
          return;
        }

        const materialLabel = event.target.closest('variant-selects label[for]');
        if (materialLabel && this.dataset.currentStep === '2') {
          window.clearTimeout(this.materialAdvanceTimer);
          this.materialAdvanceTimer = window.setTimeout(() => {
            this.materialAdvanceTimer = null;
            if (this.dataset.currentStep !== '2') return;
            this.syncSizeVariant();
            if (!this.validateConfiguration(false)) return;
            this.updateSummaries();
            this.activateStep(3, true);
          }, 160);
          return;
        }

        const trigger = event.target.closest('[data-aif-step-trigger]');
        if (!trigger) return;
        if (trigger.disabled) return;
        const targetStep = Number.parseInt(trigger.dataset.aifStepTrigger, 10);
        if (targetStep === 3 && !this.validateConfiguration()) return;
        this.activateStep(targetStep, true);
      }

      handleChange(event) {
        if (event.target.matches('input[name="Material"]')) {
          this.materialConfirmed = true;
          window.clearTimeout(this.materialAdvanceTimer);
          this.materialAdvanceTimer = null;
        }
        this.updateSummaries();

        if (event.target.matches('input[name="Material"]')) {
          const shouldAdvance = !this.syncingMaterialChoice;
          window.requestAnimationFrame(() => {
            this.syncSizeVariant();
            this.updateSummaries();
            if (shouldAdvance && this.dataset.currentStep === '2') {
              this.activateStep(3, true);
            }
          });
          return;
        }
      }

      handleVariantChange() {
        window.requestAnimationFrame(() => this.syncSizeVariant());
      }

      selectSize(size) {
        const selectedProduct = this.sizeProducts?.[size];
        if (selectedProduct?.handle && selectedProduct.handle !== this.dataset.productHandle) {
          const nextUrl = new URL(selectedProduct.url, window.location.origin);
          const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewThemeId) nextUrl.searchParams.set('preview_theme_id', previewThemeId);
          nextUrl.searchParams.set('aif_step', '2');
          window.location.assign(nextUrl.toString());
          return;
        }

        this.selectedSize = size;
        this.materialConfirmed = false;
        this.querySelectorAll('[data-aif-size-choice]').forEach((choice) => {
          const isSelected = choice.dataset.aifSizeChoice === size;
          choice.classList.toggle('is-current', isSelected);
          choice.toggleAttribute('data-aif-current-size', isSelected);
          choice.setAttribute('aria-pressed', String(isSelected));
        });

        this.syncSizeVariant();
        this.updateSummaries();
        this.activateStep(this.hasSingleMaterial ? 3 : 2, true);
      }

      syncSizeVariant() {
        const variants = this.sizeProducts?.[this.selectedSize]?.variants || [];
        const availableVariants = variants.filter((variant) => variant.available);
        const materialInputs = Array.from(this.section.querySelectorAll('input[name="Material"]'));

        materialInputs.forEach((input) => {
          const mappedVariant = availableVariants.find((variant) => variant.option1 === input.value);
          input.disabled = !mappedVariant;
          const label = this.section.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          label?.classList.toggle('aif-option-unavailable', !mappedVariant);
        });
        this.updateMaterialStepAvailability(materialInputs);

        if (!this.hasSingleMaterial && !this.materialConfirmed) {
          materialInputs.forEach((input) => {
            input.checked = false;
          });
          delete this.dataset.selectedVariantId;
          const materialValue = this.section.querySelector('variant-selects .form__label-value');
          const placeholder = this.dataset.materialPlaceholder;
          if (materialValue && placeholder && materialValue.textContent.trim() !== placeholder) {
            materialValue.textContent = placeholder;
          }
          return;
        }

        let materialInput = materialInputs.find((input) => input.checked && !input.disabled);
        if (!materialInput) {
          materialInput = materialInputs.find((input) => !input.disabled);
          this.syncingMaterialChoice = true;
          materialInput?.click();
          this.syncingMaterialChoice = false;
          return;
        }

        const selectedVariant = availableVariants.find((variant) => variant.option1 === materialInput.value);
        if (!selectedVariant) return;

        const variantIdInput = this.form.querySelector('.product-variant-id');
        if (variantIdInput) {
          variantIdInput.value = String(selectedVariant.id);
          variantIdInput.setAttribute('value', String(selectedVariant.id));
          variantIdInput.disabled = false;
        }

        this.dataset.selectedVariantId = String(selectedVariant.id);
        this.updatePrice(selectedVariant.price);
      }

      updatePrice(price) {
        if (!Number.isFinite(price)) return;

        this.currentVariantPrice = price;

        const formattedPrice = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        }).format(price / 100);

        this.querySelectorAll('[data-aif-current-price]').forEach((element) => {
          if (element.textContent !== formattedPrice) element.textContent = formattedPrice;
        });
        this.updateShippingMessaging(price);
      }

      updateMaterialStepAvailability(materialInputs) {
        this.hasSingleMaterial = materialInputs.filter((input) => !input.disabled).length === 1;
        this.classList.toggle('has-single-material', this.hasSingleMaterial);

        const materialNav = this.querySelector('[data-aif-nav-step="2"]');
        if (materialNav) materialNav.hidden = this.hasSingleMaterial;

        const finalNumber = this.querySelector('[data-aif-nav-step="3"] .aif-purchase-step__number');
        const nextFinalNumber = this.hasSingleMaterial ? '2' : '3';
        if (finalNumber && finalNumber.textContent !== nextFinalNumber) finalNumber.textContent = nextFinalNumber;

        const finalBackButton = this.querySelector('[data-aif-step="3"] [data-aif-back-step]');
        if (finalBackButton) finalBackButton.dataset.aifBackStep = this.hasSingleMaterial ? '1' : '2';
      }

      updateShippingMessaging(price) {
        if (!Number.isFinite(price)) return;

        const qualifies = this.shippingThreshold > 0 && price >= this.shippingThreshold;
        if (qualifies) {
          this.dataset.aifShippingStatus = 'qualified';
        } else {
          delete this.dataset.aifShippingStatus;
        }

        const shippingNeeded = this.querySelector('[data-aif-shipping-needed]');
        const shippingQualified = this.querySelector('[data-aif-shipping-qualified]');
        const progressTarget = this.querySelector('[data-aif-step-four-progress]');
        if (shippingNeeded) shippingNeeded.hidden = qualifies;
        if (shippingQualified) shippingQualified.hidden = !qualifies;
        if (progressTarget) progressTarget.hidden = qualifies;

        const upsellTitle = this.querySelector(
          '[data-essential-upsell-element="header"] [data-essential-upsell-element="title"]'
        );
        if (!upsellTitle) return;

        if (!upsellTitle.dataset.aifOriginalTitle) {
          upsellTitle.dataset.aifOriginalTitle = upsellTitle.textContent.trim();
        }

        const nextTitle = qualifies
          ? this.dataset.qualifiedUpsellTitle
          : upsellTitle.dataset.aifOriginalTitle;
        if (nextTitle && upsellTitle.textContent.trim() !== nextTitle) upsellTitle.textContent = nextTitle;
      }

      handleSubmit(event) {
        this.syncSizeVariant();
        if (!this.validateConfiguration()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.activateStep(2, true);
        }
      }

      validateConfiguration(showFeedback = true) {
        const error = this.querySelector('[data-aif-step-error="2"]');
        const selectedMaterial = this.section.querySelector('input[name="Material"]:checked:not(:disabled)');
        const isValid = this.hasSingleMaterial || (this.materialConfirmed && Boolean(selectedMaterial));
        if (error) {
          error.hidden = isValid || !showFeedback;
          if (!isValid && showFeedback) error.textContent = this.dataset.materialPlaceholder || '';
        }
        return isValid;
      }

      activateStep(stepNumber, focusHeading) {
        if (stepNumber === 2 && this.hasSingleMaterial) stepNumber = 3;
        this.maxUnlockedStep = Math.max(this.maxUnlockedStep || 1, stepNumber);
        this.dataset.currentStep = String(stepNumber);
        this.querySelectorAll('[data-aif-step]').forEach((step) => {
          const isCurrent = Number.parseInt(step.dataset.aifStep, 10) === stepNumber;
          step.classList.toggle('is-current', isCurrent);
          step.hidden = !isCurrent;
          const content = step.querySelector('[data-aif-step-content]');
          if (content) content.hidden = !isCurrent;
        });

        this.querySelectorAll('[data-aif-step-trigger]').forEach((trigger) => {
          const triggerStep = Number.parseInt(trigger.dataset.aifStepTrigger, 10);
          const navStep = trigger.closest('[data-aif-nav-step]');
          const isCurrent = triggerStep === stepNumber;
          const isComplete = triggerStep < stepNumber;
          trigger.disabled = triggerStep > this.maxUnlockedStep;
          if (isCurrent) {
            trigger.setAttribute('aria-current', 'step');
          } else {
            trigger.removeAttribute('aria-current');
          }
          navStep?.classList.toggle('is-current', isCurrent);
          navStep?.classList.toggle('is-complete', isComplete);
        });

        if (focusHeading) {
          const trigger = this.querySelector(`[data-aif-step-trigger="${stepNumber}"]`);
          window.requestAnimationFrame(() => trigger?.focus({ preventScroll: true }));
        }
      }

      updateSummaries() {
        const sizeSummary = this.querySelector('[data-aif-step-summary="1"]');
        if (sizeSummary) sizeSummary.textContent = this.selectedSize || 'Medium';

        const selectedMaterial = this.section.querySelector('input[name="Material"]:checked')?.value;
        const chainSummary = this.querySelector('[data-aif-step-summary="2"]');
        const summaryParts = [selectedMaterial].filter(Boolean);
        if (chainSummary && summaryParts.length) chainSummary.textContent = summaryParts.join(' · ');

        const extrasSummary = this.querySelector('[data-aif-step-summary="3"]');
        const extrasParts = [this.selectedSize, selectedMaterial].filter(Boolean);
        if (extrasSummary && extrasParts.length) extrasSummary.textContent = extrasParts.join(' · ');
      }
    }

    customElements.define('aif-purchase-flow', AifPurchaseFlow);
  }
  } catch(e) { console.error(e); }
})();

})();
